import * as React from 'react'
import { Provider } from 'react-redux'
import { PersistGate } from 'redux-persist/integration/react'
import { store, persistor } from './store/store'
import { makeTestStore } from './store/make-store'
import { store as simulatorStore } from './store/store.simulator'

interface SimulatorDataProviderProps {
  children: React.ReactNode
}

interface DataProviderProps {
  children: React.ReactNode
}

export const DataProvider = ({ children }: DataProviderProps): JSX.Element => {
  return (
    <Provider store={store}>
      <PersistGate
        loading={null}
        persistor={persistor}
      >
        {children}
      </PersistGate>
    </Provider>
  )
}

export const SimulatorDataProvider = ({ children }: SimulatorDataProviderProps): JSX.Element => {
  return <Provider store={simulatorStore}>{children}</Provider>
}

interface TestDataProviderProps {
  children: React.ReactNode
  modifiedState: any
}

export const TestDataProvider = ({ children, modifiedState }: TestDataProviderProps): JSX.Element => {
  const modifiedStore = makeTestStore(modifiedState)
  return <Provider store={modifiedStore}>{children}</Provider>
}
